import React from "react";
import PropTypes from "prop-types";
import LatestStoryCard from "../../../../../atoms/Latest-story-card";

import styles from "./styles.m.css";
import { get } from "lodash";

const LatestStoryWidget = props => {
  const story = get(props.collection, ["items"], null);
  const stories = story && story !== undefined ? story.map(item => item.story) : [];

  const slides =
    stories &&
    stories !== undefined &&
    stories.map(item => <LatestStoryCard key={item.id} story={item} className={styles.card} />);
  return stories.length ? (
    <div className={`${styles.base}`}>
      {props.collection.name && (
        <h4 className={`${styles.headline}`}>
          <span>{props.type === "videos" ? "லேட்டஸ்ட் வீடியோஸ்" : "லேட்டஸ்ட் செய்திகள்"}</span>
        </h4>
      )}
      <div className={styles["stories-container"]}>{slides}</div>
    </div>
  ) : null;
};

LatestStoryWidget.propTypes = {
  className: PropTypes.string,
  CrStory: PropTypes.object,
  collection: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    items: PropTypes.array
  }),
  numberOfCardsInViewDesktop: PropTypes.number,
  numberOfCardsInViewTablet: PropTypes.number,
  numberOfCardsInViewMobile: PropTypes.number,
  type: PropTypes.string
};

export default LatestStoryWidget;
